import type { CoachJourneyInput } from '../schema';
import { contentStudioJourney } from './contentStudio';

/**
 * Someone's first time in Poppy: the same path as Content Studio, so both tours feel the same.
 * One question about their niche, what's working in it shown right in Copilot, a script they
 * send for, then filming, editing and posting. Only the welcome and keeping the answer on the
 * board as "About you" differ.
 */
export const welcomeJourney: CoachJourneyInput = {
  id: 'welcome-to-poppy',
  version: 3,
  name: 'Welcome to Poppy',
  description:
    'Tell Poppy your niche, see what’s working in it, and make your first video on one board.',
  mode: 'standard',
  gate: { flag: 'scriptShootPost' },
  start: { link: true },
  tutorial: {
    description: 'Your niche. What’s working in it. Your first video. One board to keep.',
    on: 'new-board',
  },
  steps: contentStudioJourney.steps.map(step => {
    if (step.id === 'open')
      return { ...step, title: 'Your board is waiting ✨', body: 'Opening your welcome board.' };
    if (step.id === 'welcome')
      return {
        ...step,
        title: 'Welcome to Poppy 🌸',
        body: 'Tell me what you make content about. Poppy finds what’s working in your niche and writes your first script, then you film it. Everything stays on this board ✨',
        action: { label: 'Let’s make it mine', to: 'brief' },
      };
    if (step.id === 'brief') {
      const { to: _to, ...form } = step.form!;
      return {
        ...step,
        form,
        // The answer stays on the board, the first thing on it that's theirs.
        do: {
          action: 'board.add-note' as const,
          params: { title: 'About you', textFrom: 'brief' },
          bind: { nodeId: 'briefNodeId' },
          then: 'find-examples',
        },
      };
    }
    return step;
  }),
};
